<template>
  <div>
    <apexchart type="pie" width="380" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>
<script>
export default {
  props: {
    defaults: Object,
    model: { type: Object, default: () => {} },
  },
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      series: [44, 55, 13, 43, 22],
      chartOptions: {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: ["Team A", "Team B", "Team C", "Team D", "Team E"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
  },
  created() {
    //this.init();
  },
  computed: {
    config() {
      let res = Object.assign({}, this.model.config);
      res.value = this.value;
      return res;
    },
  },
  methods: {
    async init() {
      if (!this.model.type) return;
      let params = {};
      const user = { id: this.$root.profile.id };
      let resp;
      if (this.model.type == "badgeApi") {
        if (typeof this.model.api === "object") {
          this.api = this.model.api.api;
          //params = JSON.parse(this.model.api.params || "{}");
          //console.log("try eval", this.model.api.params);
          try {
            params = eval("(" + (this.model.api.params || "{}") + ")");
          } catch (error) {}
        }
        if (!this.api) return;
        this.loading = true;
        resp = await this.$axios.get(this.api, { params });
      } else if (this.model.type == "badge") {
      } else return;
      let value;
      if (typeof this.model.value === "object") {
        if (this.model.value.type == "function") {
          let f = this.model.value.func;
          value = eval(f)(resp);
        }
      }
      this.value = value;
      this.loading = false;
    },
  },
};
</script>
